import { Const } from '../constants/Constants';
import { Message } from '../constants/Message';
import { generateMessage } from '../util/MessageUtil';
/**
 * 結果ーコード空からメッセージを取得
 *
 * @param resultCd API結果コード
 * @return メッセージ
 */
export const getMessage = (resultCd: String, dispNm: string) => {

    let msg: string = '';
    if (resultCd === Const.RESULT_CODE.ACCOUNT_LOCK) {
        msg = Message.ERROR_MASSAGE.ERR002
    } else if (resultCd === Const.RESULT_CODE.INIT_PASSWORD) {
        msg = Message.ERROR_MASSAGE.ERR003
    } else if (resultCd === Const.RESULT_CODE.EXPIRED_PASS) {
        msg = Message.ERROR_MASSAGE.ERR004
    } else if (resultCd === Const.RESULT_CODE.NG_PASS) {
        msg = Message.ERROR_MASSAGE.ERR005
    } else if (resultCd === Const.RESULT_CODE.ILLEGAL_PASS) {
        msg = Message.ERROR_MASSAGE.ERR007
    } else if (resultCd === Const.RESULT_CODE.DUPLICATE_PASS) {
        msg = Message.ERROR_MASSAGE.ERR008
    } else if (resultCd === Const.RESULT_CODE.NOT_EXIST_MAIL_ADD) {
        msg = Message.ERROR_MASSAGE.ERR009
    } else if (resultCd === Const.RESULT_CODE.NOT_EXIST_HINMOKU_INFO) {
        msg = Message.ERROR_MASSAGE.ERR010
    } else if (resultCd === Const.RESULT_CODE.NOT_EXIST_KOJI_KANRI_NO) {
        msg = Message.ERROR_MASSAGE.ERR011
    } else if (resultCd === Const.RESULT_CODE.NOT_EXIST_JUCHU) {
        msg = Message.ERROR_MASSAGE.ERR012
    } else if (resultCd === Const.RESULT_CODE.DELETED_JUCHU) {
        msg = Message.ERROR_MASSAGE.ERR013
    } else if (resultCd === Const.RESULT_CODE.NOT_EXIST_ACCOUNT) {
        msg = Message.ERROR_MASSAGE.ERR014
    } else if (resultCd === Const.RESULT_CODE.DIFFERENT_PASS) {
        msg = Message.ERROR_MASSAGE.ERR015
    } else if (resultCd === Const.RESULT_CODE.SYSTEM_ERR) {
        msg = generateMessage(Message.ERROR_MASSAGE.ERR999, dispNm)
    };

    return msg;
};
